<template>
  <div class="dashboard-container">
    <div class="panel-container">
      <div class="level-1-heading">
        <span class="title-icon"></span>
        <span class="title"> 常用模块</span>
      </div>
      <div class="panel-box">
        <div class="common-panel">
          <el-row>
            <el-col :span="5" class="panel-img flowInstances-wait"></el-col>
            <el-col class="margin-12" :span="17">
              <div class="tem-title">待办流程</div>
              <div class="f-12">待办流程查看，审批</div>
            </el-col>
          </el-row>
          <div class="link-container">
            <div class="link-text">
              <router-link to="/flowInstances/wait" class="f-12">点击进入 <i class="icon el-icon-arrow-right"></i></router-link>
            </div>
          </div>
        </div>
        <div class="common-panel">
          <el-row>
            <el-col :span="5" class="panel-img flowInstances-index"></el-col>
            <el-col class="margin-12" :span="17">
              <div class="tem-title">我的流程</div>
              <div class="f-12">申请编辑流程</div>
            </el-col>
          </el-row>
          <div class="link-container">
            <div class="link-text">
              <router-link to="/flowInstances/Index" class="f-12">点击进入 <i class="icon el-icon-arrow-right"></i></router-link>
            </div>
          </div>
        </div>
        <div class="common-panel">
          <el-row>
            <el-col :span="5" class="panel-img flowInstances-disposed"></el-col>
            <el-col class="margin-12" :span="17">
              <div class="tem-title">已办流程</div>
              <div class="f-12">已办流程查看</div>
            </el-col>
          </el-row>
          <div class="link-container">
            <div class="link-text">
              <router-link to="/flowInstances/disposed" class="f-12">点击进入 <i class="icon el-icon-arrow-right"></i></router-link>
            </div>
          </div>
        </div>
        <div class="common-panel">
          <el-row>
            <el-col :span="5" class="panel-img sysMessages-Index"></el-col>
            <el-col class="margin-12" :span="17">
              <div class="tem-title">我的消息</div>
              <div class="f-12">待办流程查看，审批</div>
            </el-col>
          </el-row>
          <div class="link-container">
            <div class="link-text">
              <router-link to="/SysMessages/Index" class="f-12">点击进入 <i class="icon el-icon-arrow-right"></i></router-link>
            </div>
          </div>
        </div>
        <div class="common-panel">
          <el-row>
            <el-col :span="5" class="panel-img sysLogs-Index"></el-col>
            <el-col class="margin-12" :span="17">
              <div class="tem-title">系统日志</div>
              <div class="f-12">日志搜索、查看</div>
            </el-col>
          </el-row>
          <div class="link-container">
            <div class="link-text">
              <router-link to="/SysLogs/Index" class="f-12">点击进入 <i class="icon el-icon-arrow-right"></i></router-link>
            </div>
          </div>
        </div>
      </div>
      <div class="panel-box">
        <div class="common-panel">
          <el-row>
            <el-col :span="5" class="panel-img roleManager-Index"></el-col>
            <el-col class="margin-12" :span="17">
              <div class="tem-title">角色管理</div>
              <div class="f-12">系统角色分配、删除管理</div>
            </el-col>
          </el-row>
          <div class="link-container">
            <div class="link-text">
              <router-link to="/RoleManager/Index" class="f-12">点击进入 <i class="icon el-icon-arrow-right"></i></router-link>
            </div>
          </div>
        </div>
        <div class="common-panel">
          <el-row>
            <el-col :span="5" class="panel-img userManager-Index"></el-col>
            <el-col class="margin-12" :span="17">
              <div class="tem-title">用户管理</div>
              <div class="f-12">系统用户增删改查</div>
            </el-col>
          </el-row>
          <div class="link-container">
            <div class="link-text">
              <router-link to="/UserManager/Index" class="f-12">点击进入 <i class="icon el-icon-arrow-right"></i></router-link>
            </div>
          </div>
        </div>
        <div class="common-panel">
          <el-row>
            <el-col :span="5" class="panel-img forms-index"></el-col>
            <el-col class="margin-12" :span="17">
              <div class="tem-title">表单设计</div>
              <div class="f-12">系统表单增加、修改</div>
            </el-col>
          </el-row>
          <div class="link-container">
            <div class="link-text">
              <router-link to="/forms/index" class="f-12">点击进入 <i class="icon el-icon-arrow-right"></i></router-link>
            </div>
          </div>
        </div>
        <div class="common-panel">
          <el-row>
            <el-col :span="5" class="panel-img flowSchemes-index"></el-col>
            <el-col class="margin-12" :span="17">
              <div class="tem-title">流程设计</div>
              <div class="f-12">系统流程增加、修改</div>
            </el-col>
          </el-row>
          <div class="link-container">
            <div class="link-text">
              <router-link to="/flowSchemes/index" class="f-12">点击进入 <i class="icon el-icon-arrow-right"></i></router-link>
            </div>
          </div>
        </div>
        <div class="common-panel">
          <el-row>
            <el-col :span="5" class="panel-img uploadfiles-index"></el-col>
            <el-col class="margin-12" :span="17">
              <div class="tem-title">附件管理</div>
              <div class="f-12">系统附件查看，检索</div>
            </el-col>
          </el-row>
          <div class="link-container">
            <div class="link-text">
              <router-link to="/uploadfiles/index" class="f-12">点击进入 <i class="icon el-icon-arrow-right"></i></router-link>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="panel-container">
      <div class="level-1-heading">
        <span class="title-icon"></span>
        <span class="title"> 常用帮助</span>
      </div>
      <div class="m-t-24 panel-box">
        <div class="common-panel">
          <el-row>
            <el-col v-if="!isDisabled" class="panel-img information" :span="5"></el-col>
            <el-col v-if="isDisabled" class="panel-img information-disable" :span="5"></el-col>
            <el-col class="margin-12" :span="17">
              <div class="tem-title">发布通知</div>
              <div class="f-12">系统版本发布，请及时更新</div>
            </el-col>
          </el-row>
          <div class="link-container">
            <div v-if="!isDisabled" class="link-text">
              <router-link to="/" class="f-12">点击进入 <i class="icon el-icon-arrow-right"></i></router-link>
            </div>
            <div v-if="isDisabled" class="link-text-disable">
              <span class="f-12">点击进入</span>
            </div>
          </div>
        </div>
        <div class="common-panel">
          <el-row>
            <el-col v-if="!isDisabled" class="panel-img operation-manual" :span="5"></el-col>
            <el-col v-if="isDisabled" class="panel-img operation-manual-disable" :span="5"></el-col>
            <el-col class="margin-12" :span="17">
              <div class="tem-title">操作手册</div>
              <div class="f-12">常用操作手册、视频等</div>
            </el-col>
          </el-row>
          <div class="link-container">
            <div v-if="!isDisabled" class="link-text">
              <router-link to="/" class="f-12">点击进入 <i class="icon el-icon-arrow-right"></i></router-link>
            </div>
            <div v-if="isDisabled" class="link-text-disable">
              <span class="f-12">点击进入</span>
            </div>
          </div>
        </div>
        <div class="common-panel">
          <el-row>
            <el-col v-if="!isDisabled" class="panel-img software" :span="5"></el-col>
            <el-col v-if="isDisabled" class="panel-img software-disable" :span="5"></el-col>
            <el-col class="margin-12" :span="17">
              <div class="tem-title">常用软件</div>
              <div class="f-12">常用软件下载，一站式服务</div>
            </el-col>
          </el-row>
          <div class="link-container">
            <div v-if="!isDisabled" class="link-text">
              <router-link to="/" class="f-12">点击进入 <i class="icon el-icon-arrow-right"></i></router-link>
            </div>
            <div v-if="isDisabled" class="link-text-disable">
              <span class="f-12">点击进入</span>
            </div>
          </div>
        </div>
        <div class="common-panel">
          <el-row>
            <el-col v-if="!isDisabled" class="panel-img suggestions" :span="5"></el-col>
            <el-col v-if="isDisabled" class="panel-img suggestions-disable" :span="5"></el-col>
            <el-col class="margin-12" :span="17">
              <div class="tem-title">意见建议</div>
              <div class="f-12">系统建议、意见反馈</div>
            </el-col>
          </el-row>
          <div class="link-container">
            <div v-if="!isDisabled" class="link-text">
              <router-link to="/" class="f-12">点击进入 <i class="icon el-icon-arrow-right"></i></router-link>
            </div>
            <div v-if="isDisabled" class="link-text-disable">
              <span class="f-12">点击进入</span>
            </div>
          </div>
        </div>
        <div class="common-panel">
          <el-row>
            <el-col v-if="!isDisabled" class="panel-img online" :span="5"></el-col>
            <el-col v-if="isDisabled" class="panel-img online-disable" :span="5"></el-col>
            <el-col class="margin-12" :span="17">
              <div class="tem-title">在线咨询</div>
              <div class="f-12">在线客服服务、专业咨询</div>
            </el-col>
          </el-row>
          <div class="link-container">
            <div v-if="!isDisabled" class="link-text">
              <router-link to="/" class="f-12">点击进入 <i class="icon el-icon-arrow-right"></i></router-link>
            </div>
            <div v-if="isDisabled" class="link-text-disable">
              <span class="f-12">点击进入</span>
            </div>
          </div>
        </div>
      </div>
    </div>
<!--    <component :is="currentRole"></component>-->
  </div>
</template>

<script>
// import adminDashboard from './admin'

export default {
  name: 'dashboard',
  components: {
    // adminDashboard
  },
  data() {
    return {
      currentRole: 'adminDashboard',
      isDisabled: true,
    }
  }
}
</script>
<style rel="stylesheet/scss" lang="scss" scoped>
  .panel-container{
    padding: 24px 32px;
    /*position: absolute;*/
    width: 100%;
  }
  .level-1-heading {
    display: inline-block;
    font-size: 20px;
    font-weight: bold;
    .title-icon {
      display: inline-block;
      width: 5px;
      height: 30px;
      background: #244EE9;
      position: absolute;
      left: 35px;
    }

    .title {
      margin-left: 20px;
    }
  }
  .panel-box{
    margin-top: 25px;
    display: flex;
    justify-content: space-between;
  }
  .common-panel{
    width: 18%;
    height: 120px;
    border-radius: 4px;
    box-shadow: 0 0 8px 2px #eaeff2;
    margin-bottom: 32px;
    background: #fff;
    >div:first-child{padding: 18px 24px;}
    .tem-title{
      font-size: 14px;
      font-weight: bold;
      margin-bottom: 10px;
    }
    .margin-12{
      margin-left: 12px;
    }
    .link-container{
      border-top: 2px solid #ebf2fa;
    }
    .f-12{font-size: 12px;}
    .link-text{
      line-height: 38px;
      text-align: center;
      a{
        color: #3BAC4A;
        text-decoration: none;
        display: inline-block;
        width: 100%;
      }
      .icon{ display: none;}
      &:hover{
        background: #3BAC4A;
        border-radius: 0 0 4px 4px;
        cursor: pointer;
        a{
          color: #fff;
        }
        .icon{
          display: inline-block;
          margin-top: -2px;
        }
      }
    }
    .link-text-disable{
      text-align: center;
      line-height: 32px;
      span{
        color: #666;
      }
    }
    .panel-img{
      height: 40px;
    }
    .flowInstances-wait{
      background: url('~@/assets/dashboard/cust_info.png') 100% 100% no-repeat;
      background-size: contain;
    }
    .flowInstances-wait-disable{
      background: url('~@/assets/dashboard/unavailable/cust_info_un.png') 100% 100% no-repeat;
      background-size: contain;
    }
    .flowInstances-index{
      background: url('~@/assets/dashboard/cust_create.png') 100% 100% no-repeat;
      background-size: contain;
    }
    .flowInstances-index-disable{
      background: url('~@/assets/dashboard/unavailable/cust_create_un.png') 100% 100% no-repeat;
      background-size: contain;
    }
    .flowInstances-disposed{
      background: url('~@/assets/dashboard/at_charges.png') 100% 100% no-repeat;
      background-size: contain;
    }
    .flowInstances-disposed-disable{
      background: url('~@/assets/dashboard/unavailable/at_charges_un.png') 100% 100% no-repeat;
      background-size: contain;
    }
    .sysMessages-Index{
      background: url('~@/assets/dashboard/Inform-management.png') 100% 100% no-repeat;
      background-size: contain;
    }
    .sysMessages-Index-disable{
      background: url('~@/assets/dashboard/unavailable/inform-management-un.png') 100% 100% no-repeat;
      background-size: contain;
    }
    .sysLogs-Index{
      background: url('~@/assets/dashboard/meter_check.png') 100% 100% no-repeat;
      background-size: contain;
    }
    .sysLogs-Index-disable{
      background: url('~@/assets/dashboard/unavailable/meter_check_un.png') 100% 100% no-repeat;
      background-size: contain;
    }
    .roleManager-Index{
      background: url('~@/assets/dashboard/arrears_search.png') 100% 100% no-repeat;
      background-size: contain;
    }
    .roleManager-Index-disable{
      background: url('~@/assets/dashboard/unavailable/arrears_search_un.png') 100% 100% no-repeat;
      background-size: contain;
    }
    .userManager-Index{
      background: url('~@/assets/dashboard/arrearage_reminder.png') 100% 100% no-repeat;
      background-size: contain;
    }
    .userManager-Index-disable{
      background: url('~@/assets/dashboard/unavailable/arrearage_reminder_un.png') 100% 100% no-repeat;
      background-size: contain;
    }
    .forms-index{
      background: url('~@/assets/dashboard/invoice_create.png') 100% 100% no-repeat;
      background-size: contain;
    }
    .forms-index-disable{
      background: url('~@/assets/dashboard/unavailable/invoice_create_un.png') 100% 100% no-repeat;
      background-size: contain;
    }
    .flowSchemes-index{
      background: url('~@/assets/dashboard/meter_replace.png') 100% 100% no-repeat;
      background-size: contain;
    }
    .flowSchemes-index-disable{
      background: url('~@/assets/dashboard/unavailable/meter_replace_un.png') 100% 100% no-repeat;
      background-size: contain;
    }
    .uploadfiles-index{
      background: url('~@/assets/dashboard/search_report.png') 100% 100% no-repeat;
      background-size: contain;
    }
    .uploadfiles-index-disable{
      background: url('~@/assets/dashboard/unavailable/search_report_un.png') 100% 100% no-repeat;
      background-size: contain;
    }
    .information{
      background: url('~@/assets/dashboard/information.png') 100% 100% no-repeat;
      background-size: contain;
    }
    .information-disable{
      background: url('~@/assets/dashboard/unavailable/information_un.png') 100% 100% no-repeat;
      background-size: contain;
    }
    .operation-manual{
      background: url('~@/assets/dashboard/operation_manual.png') 100% 100% no-repeat;
      background-size: contain;
    }
    .operation-manual-disable{
      background: url('~@/assets/dashboard/unavailable/operation_manual_un.png') 100% 100% no-repeat;
      background-size: contain;
    }
    .software{
      background: url('~@/assets/dashboard/software.png') 100% 100% no-repeat;
      background-size: contain;
    }
    .software-disable{
      background: url('~@/assets/dashboard/unavailable/software_un.png') 100% 100% no-repeat;
      background-size: contain;
    }
    .suggestions{
      background: url('~@/assets/dashboard/suggestions.png') 100% 100% no-repeat;
      background-size: contain;
    }
    .suggestions-disable{
      background: url('~@/assets/dashboard/unavailable/suggestions_un.png') 100% 100% no-repeat;
      background-size: contain;
    }
    .online{
      background: url('~@/assets/dashboard/online.png') 100% 100% no-repeat;
      background-size: contain;
    }
    .online-disable{
      background: url('~@/assets/dashboard/unavailable/online_un.png') 100% 100% no-repeat;
      background-size: contain;
    }
  }
  @media screen and (max-width: 1680px) {
    .common-panel {
      width: 19%;
      height: 126px;
      > div:first-child {
        padding: 20px 9px;
      }
    }
  }
  @media screen and (max-width: 1400px) {
    .common-panel {
      width: 19%;
      height: 140px;
      > div:first-child {
        min-height: 98px;
        padding: 18px 9px;
      }
    }
  }
</style>
